module.exports = __webpack_public_path__ + "media/find.e0c9e323.mp3";